import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-vue-nav-contacts",
  "use": "foquz-icon-vue-nav-contacts-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-vue-nav-contacts\"><path d=\"M15 19v-2a3 3 0 00-3-3H5a3 3 0 00-3 3v2m16-4h2a2 2 0 012 2v2M11 7.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zM19 9a2 2 0 11-4 0 2 2 0 014 0z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol